var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw-flex-row tw-w-full"},[_c('div',{staticClass:"tw-px-4 tw-border-gray-400"},[_c('h1',[_vm._v("API Tokens")]),_c('ApiTokens')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }